export default __webpack_public_path__ + "static/media/king.21801e8f.png";